Em.Handlebars.helper 'skypeLink', (phone) ->
  if phone
    regExp = new RegExp(' |(-)|\\(|\\)', 'g')
    phone = phone.replace(regExp, '')
    return new Handlebars.SafeString "tel:#{phone}"

Em.Handlebars.helper 'formatPhone', (phone) ->
  return "" if not phone

  prefix = ""
  if phone[0] == "+"
    prefix = "+"
    phone = phone.substring 1

  regExp = new RegExp(' |(-)|\\(|\\)', 'g')
  p = phone.replace(regExp, '')

  return p if p.length < 9

  "#{prefix}#{p[0]} (#{p[1..3]}) #{p[4..6]}-#{p[7..8]}-#{p[9..10]}"
